// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"kC","header":"kD"};